"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAddressModalTexts = void 0;
const AddressModalLiterals = __importStar(require("../constants"));
const translations_1 = require("../../translations");
const useAddressModalTexts = () => {
    const getMaxLengthMessage = (literal, maxLength, currentCharacters) => (0, translations_1.translate)(literal, {
        maxLength: maxLength ? maxLength.toString() : '',
        currentCharacters: currentCharacters ? currentCharacters.toString() : '0',
    });
    return {
        utils: {
            getMaxLengthMessage,
        },
        accesibility: {
            altErrorIcon: (0, translations_1.translate)(AddressModalLiterals.ALT_ERROR_ICON),
            altDropdownIcon: (0, translations_1.translate)(AddressModalLiterals.ALT_DROPDOWN_ICON),
            altStateSearchIcon: (0, translations_1.translate)(AddressModalLiterals.ALT_STATE_SEARCH_ICON),
            altAddressLineSearchIcon: (0, translations_1.translate)(AddressModalLiterals.ALT_ADDRESS_LINE_SEARCH_ICON),
            ariaLabelCloseDropdown: (0, translations_1.translate)(AddressModalLiterals.ARIA_LABEL_CLOSE_DROPDOWN),
            closeIcon: (0, translations_1.translate)(AddressModalLiterals.MODAL_DEFAULT_CLOSE_ICON),
            loadingState: (0, translations_1.translate)(AddressModalLiterals.LOADING_STATE),
            dropdownCloseIconAriaLabel: (0, translations_1.translate)(AddressModalLiterals.DROPDOWN_CLOSE_ICON_ARIA_LABEL),
            dropdownOptionsAriaLabel: (0, translations_1.translate)(AddressModalLiterals.DROPDOWN_OPTIONS_ARIA_LABEL),
            screenReaderValidFieldMessage: (0, translations_1.translate)(AddressModalLiterals.SCREEN_READER_VALID_FIELD_MESSAGE),
            ruralCategoryTypeAriaLabel: (0, translations_1.translate)(AddressModalLiterals.RURAL_CATEGORY_TYPE_ARIA_LABEL),
            militaryCategoryTypeAriaLabel: (0, translations_1.translate)(AddressModalLiterals.MILITARY_CATEGORY_TYPE_ARIA_LABEL),
            modalCharactersCountText: AddressModalLiterals.MODAL_CHARACTERS_COUNT_TEXT,
        },
        defaultGeneralTexts: {
            title: (0, translations_1.translate)(AddressModalLiterals.MODAL_DEFAULT_TITLE),
            description: (0, translations_1.translateToComponent)(AddressModalLiterals.MODAL_DEFAULT_DESCRIPTION),
            cancelButton: (0, translations_1.translate)(AddressModalLiterals.MODAL_DEFAULT_CANCEL_BUTTON_TEXT),
            confirmButton: (0, translations_1.translate)(AddressModalLiterals.MODAL_DEFAULT_CONFIRM_BUTTON_TEXT),
        },
        defaultErrorMSG: {
            incorrectFormat: (0, translations_1.translate)(AddressModalLiterals.INCORRECT_FORMAT_INPUT_ERROR),
            maxLength: AddressModalLiterals.MAX_LENGTH_ERROR_MESSAGE,
            notAllowedValue: (0, translations_1.translate)(AddressModalLiterals.GOOGLE_PLACES_INPUT_ERROR),
            requiredValueError: (0, translations_1.translate)(AddressModalLiterals.REQUIRED_VALUE_ERROR_MESSAGE),
        },
        fields: {
            addressType: {
                label: (0, translations_1.translate)(AddressModalLiterals.MODAL_LABEL_ADDRESS_TYPE),
                dropdown1: (0, translations_1.translate)(AddressModalLiterals.MODAL_LABEL_ADDRESS_TYPE_DROPDOWN_01),
                dropdown2: (0, translations_1.translate)(AddressModalLiterals.MODAL_LABEL_ADDRESS_TYPE_DROPDOWN_02),
                dropdown3: (0, translations_1.translate)(AddressModalLiterals.MODAL_LABEL_ADDRESS_TYPE_DROPDOWN_03),
                tooltip: {
                    link: (0, translations_1.translate)(AddressModalLiterals.MODAL_TOOLTIP_LINK),
                    title: (0, translations_1.translate)(AddressModalLiterals.MODAL_TOOLTIP_TITLE),
                    content: [
                        {
                            label: (0, translations_1.translate)(AddressModalLiterals.MODAL_TOOLTIP_STANDARD_LABEL),
                            description: (0, translations_1.translate)(AddressModalLiterals.MODAL_TOOLTIP_STANDARD_LABEL_DESCRIPTION),
                        },
                        {
                            label: (0, translations_1.translate)(AddressModalLiterals.MODAL_TOOLTIP_RURAL_LABEL),
                            description: (0, translations_1.translate)(AddressModalLiterals.MODAL_TOOLTIP_RURAL_LABEL_DESCRIPTION),
                            bullets: [
                                (0, translations_1.translate)(AddressModalLiterals.MODAL_TOOLTIP_RURAL_BULLET_01),
                                (0, translations_1.translate)(AddressModalLiterals.MODAL_TOOLTIP_RURAL_BULLET_02),
                            ],
                        },
                        {
                            label: (0, translations_1.translate)(AddressModalLiterals.MODAL_TOOLTIP_MILITAR_LABEL),
                            description: (0, translations_1.translate)(AddressModalLiterals.MODAL_TOOLTIP_MILITAR_LABEL_DESCRIPTION),
                            bullets: [
                                (0, translations_1.translate)(AddressModalLiterals.MODAL_TOOLTIP_MILITAR_BULLET_01),
                                (0, translations_1.translate)(AddressModalLiterals.MODAL_TOOLTIP_MILITAR_BULLET_02),
                                (0, translations_1.translate)(AddressModalLiterals.MODAL_TOOLTIP_MILITAR_BULLET_03),
                            ],
                        },
                    ],
                },
            },
            streetAutocomplete: {
                label: (0, translations_1.translate)(AddressModalLiterals.MODAL_LABEL_STREET_LINE_1_TEXT_BOX),
                dropdown1: (0, translations_1.translate)(AddressModalLiterals.MODAL_LABEL_ADDRESS_TYPE_USE_THIS),
                errors: {
                    incorrectFormat: (0, translations_1.translate)(AddressModalLiterals.INVALID_ADDRESS_LINE_1_FORMAT),
                    notAllowedValue: (0, translations_1.translate)(AddressModalLiterals.NOT_ALLOWED_VALUE_ADDRESS_LINE_1_ERROR),
                },
            },
            additionalInfo: {
                label: (0, translations_1.translate)(AddressModalLiterals.MODAL_LABEL_ADDITIONAL_INFO_TEXT_BOX),
                helpMessage: AddressModalLiterals.MODAL_LABEL_ADDITIONAL_INFO_OPTIONAL,
                errors: {
                    incorrectFormat: (0, translations_1.translate)(AddressModalLiterals.INVALID_ADDRESS_LINE_2_FORMAT),
                    notAllowedValue: (0, translations_1.translate)(AddressModalLiterals.NOT_ALLOWED_VALUE_ADDRESS_LINE_2_ERROR),
                },
            },
            cityRaw: {
                label: (0, translations_1.translate)(AddressModalLiterals.MODAL_LABEL_CITY_TEXT_BOX),
                errors: {
                    incorrectFormat: (0, translations_1.translate)(AddressModalLiterals.INVALID_CITY_FORMAT),
                },
            },
            box: {
                label: (0, translations_1.translate)(AddressModalLiterals.MODAL_LABEL_BOX_TEXT_BOX),
                errors: {
                    incorrectFormat: (0, translations_1.translate)(AddressModalLiterals.INVALID_BOX_FORMAT),
                },
            },
            unitRoute: {
                label: (0, translations_1.translate)(AddressModalLiterals.MODAL_LABEL_UNIT_TEXT_BOX),
                errors: {
                    incorrectFormat: (0, translations_1.translate)(AddressModalLiterals.INVALID_UNIT_ROUTE_FORMAT),
                },
            },
            state: {
                label: (0, translations_1.translate)(AddressModalLiterals.MODAL_LABEL_STATE_DROPDOWN),
                errors: {
                    invalidValue: (0, translations_1.translate)(AddressModalLiterals.INVALID_VALUE_ERROR_MESSAGE),
                },
            },
            cityDropdown: {
                label: (0, translations_1.translate)(AddressModalLiterals.MODAL_LABEL_CITY_DROPDOWN),
            },
            route: {
                label: (0, translations_1.translate)(AddressModalLiterals.MODAL_LABEL_ROUTE_TEXT_BOX),
            },
            categoryType: {
                label: (0, translations_1.translate)(AddressModalLiterals.MODAL_LABEL_CATEGORY_TYPE_DROPDOWN),
            },
            zipCode: {
                label: (0, translations_1.translate)(AddressModalLiterals.MODAL_LABEL_POST_CODE_TEXT_BOX),
                errors: {
                    incorrectFormat: (0, translations_1.translate)(AddressModalLiterals.INVALID_ZIP_CODE_FORMAT),
                },
            },
        },
    };
};
exports.useAddressModalTexts = useAddressModalTexts;
//# sourceMappingURL=useAddressModalTexts.hook.js.map